/**
 * creator:linhe
 * date:2019/05/29
 * class:本地缓存
 */
//保存复杂实体
const setJsonLocalStorageItem = function (key, value) {
    localStorage.removeItem(key);
    localStorage.setItem(key, JSON.stringify(value));
};
//读取复杂实体
const getJsonLocalStorageItem = function (key) {
    return JSON.parse(localStorage.getItem(key));
};
//保存String
const setStrLocalStorageItem = function (key, value) {
    localStorage.removeItem(key);
    localStorage.setItem(key, value)
};
//读取String
const getStrLocalStorageItem = function (key) {
    return localStorage.getItem(key)
};
//移除缓存
const removeLocalStorageItem = function (key) {
    localStorage.removeItem(key);
};
//清空缓存
const cleanLocalStorage = function () {
    localStorage.clear();
};

export default{
    setJsonLocalStorageItem:setJsonLocalStorageItem,
    getJsonLocalStorageItem:getJsonLocalStorageItem,
    setStrLocalStorageItem:setStrLocalStorageItem,
    getStrLocalStorageItem:getStrLocalStorageItem,
    removeLocalStorageItem:removeLocalStorageItem,
    cleanLocalStorage:cleanLocalStorage,
}